<template>
  <div class="row animated fadeIn">
    <div class="col-md-8 offset-md-2">
      <div class="card ">
        <div class="card-header">
          <i class="fa fa-pencil"></i>
          <strong>Usuário</strong>
        </div>
        <div class="card-block">
          <form>
            <div class="row">
              <div class="form-group col-md-6 input" :class="{'has-danger': errors.has('nome') }">
                <label class="col-form-label">Nome</label>
                <input type="text" class="form-control" name="nome" v-validate="'required'" v-model="body.user.firstName">
                <span v-show="errors.has('nome')" class="form-control-feedback">{{ errors.first('nome') }}</span>
              </div>
              <div class="form-group col-md-6 input" :class="{'has-danger': errors.has('sobrenome') }">
                <label class="col-form-label">Sobrenome</label>
                <input type="text" class="form-control" name="sobrenome" v-validate="'required'" v-model="body.user.lastName">
                <span v-show="errors.has('sobrenome')" class="form-control-feedback">{{ errors.first('sobrenome') }}</span>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6 input" :class="{'has-danger': errors.has('login') }">
                <label class="col-form-label">Login</label>
                <input type="text" class="form-control" name="login" v-validate="'required'" v-model="body.user.username">
                <span v-show="errors.has('login')" class="form-control-feedback">{{ errors.first('login') }}</span>
              </div>
  
              <div class="form-group col-md-6 input" :class="{'has-danger': errors.has('email') }">
                <label class="col-form-label">Email</label>
                <input type="text" class="form-control" name="email" v-validate="'required|email'" v-model="body.user.email">
                <span v-show="errors.has('email')" class="form-control-feedback">{{ errors.first('email') }}</span>
              </div>
            </div>
  
            <div class="row">
  
              <div class="form-group col-md-6 input" :class="{'has-danger': errors.has('senha') }">
                <label class="col-form-label">
                  Senha
                  <a href="" v-show="body.user.id !== undefined" class="" v-on:click.prevent.stop="changePassword = !changePassword">
                    <small>(trocar)</small>
                  </a>
                </label>
                <input type="password" class="form-control" name="senha" v-validate="changePassword ? 'required|confirmed:confirma senha' : ''" v-model="body.user.password" v-show="changePassword">
                <span v-show="errors.has('senha') && changePassword" class="form-control-feedback">{{ errors.first('senha') }}</span>
              </div>
  
              <div class="form-group col-md-6 input" :class="{'has-danger': errors.has('confirma senha') }" v-show="changePassword">
                <label class="col-form-label">Confirma senha</label>
                <input type="password" class="form-control" name="confirma senha">
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6 select" :class="{'has-danger': errors.has('method') }">
                <label class="col-form-label">Expiração</label>
                <select class="form-control" name="fila" v-validate="'required'" type="number" v-model.number="body.user.passwordExpiration">
                  <option value="30">30 Dias</option>
                  <option value="45">45 Dias</option>
                  <option value="60">60 dias</option>
                  <option value="0">Não expira</option>
                </select>
              </div>
  
              <div class="form-group col-md-6">
                <label class="col-form-label">Desativar</label>
                <span class="form-control">
                  <input type="checkbox" v-model="body.user.inactive">
                </span>
              </div>
            </div>
            <div class="form-group">
              <label for="inputUrl" class="col-form-label">Meta</label>
              <div v-for="(item, index) in body.user.meta" :key='index'>
                <div class="input-group">
                  <v-select taggable placeholder="Chave" :options="metaKeys" v-model="item.key" class="metadata"></v-select>
                  <span class="input-group-addon">=</span>
                  <input type="text" class="form-control col-md-3" placeholder="Valor" v-model="item.value">
                  <button type="button" v-on:click="removeMetaInfo(item)" class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>
                  <button type="button" v-on:click="newMetaInfo()" :disabled="index !== (body.user.meta.length - 1)" class="btn btn-sm btn-default"><i class="fa fa-plus"></i></button>
                </div>
              </div>
            </div>
            <br/>
            <h6>Grupos</h6>
            <hr />
            <div class="form-group">
              <v-select multiple :options="groups" v-model="selectedGroups"></v-select>
            </div>
            <br />

            <div class="card" v-if="this.$route.params.id != undefined">
              <div class="card-header">
                <div class="row">
                  <div class="col-md-10 text-left">
                    <i class="fa fa-key"></i>
                    <b>Chaves de acesso</b>
                  </div>
                  <div class="col-md-2 text-right">
                    <button type="button" class="btn btn-sm btn-secondary" @click="generateAccessKey">
                      <i class="fa fa-plus"></i> Gerar nova</button>
                  </div>
                </div>
  
              </div>
              <div class="card-block">
                <table class="table table-condensed">
                  <thead class="thead">
                    <tr>
                      <th>Id</th>
                      <th>SecretKey</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="ak in accessKeys">
                      <td>{{ ak.id }}</td>
                      <td>{{ ak.secretKey }}</td>
                      <td class="actions">
                        <button type="button" class="btn btn-sm btn-danger" @click="removeAccessKey(ak.id)">
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
  
          </form>
        </div>
        <div class="card-footer">
          <div class="pull-right">
            <router-link :to="'/mystique/users'" class="btn btn-sm">
              <i class="fa fa-chevron-left"></i> Cancelar
            </router-link>
            <button type="button" class="btn btn-sm btn-secondary" @click="saveUser">
              <i class="fa fa-save"></i> Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import axios from 'axios'

export default {
  name: 'user',
  components: {
    vSelect
  },
  data() {
    return {
      changePassword: true,
      selectedGroups: null,
      body: {
        user: {
          firstName: '',
          lastName: '',
          username: '',
          email: '',
          password: '',
          inactive: false,
          passwordExpiration: 0,
          meta: [ { key: '', value: '' } ]
        },
        groups: null
      },
      groups: [],
      accessKeys: [],
      metaKeys: []
    }
  },
  created() {
    const promiseGroups = this.loadGroups()
    this.loadMetaKeys()
    if (this.$route.params.id !== undefined) {
      this.changePassword = false

      promiseGroups.then(_ => {
        axios.get(process.env.MYSTIQUE_MANAGER_API_URL + 'users/' + this.$route.params.id).then(response => {
          var meta = response.data.user.meta || { }
          response.data.user.meta = Object.keys(meta)
            .map(function(key, index) { return { key: key, value: meta[key] } })

          this.body.user = response.data.user
          this.loadAccessKeys(this.body.user.id)
          this.selectedGroups = this.groups.filter(function (data) {
            return response.data.groups.indexOf(data.value) > -1
          })
        }).catch(err => {
          console.error(err)
          this.showError('Ops. Ocorreu um erro ao carregar o usuário.')
        })
      })
    }
  },
  watch: {
    'body.user.meta': function(newValue, oldValue) {
      if (this.body.user.meta.length === 0) {
        this.newMetaInfo()
      }
    }
  },
  methods: {
    newMetaInfo: function () {
      this.body.user.meta.push({
        key: '', value: ''
      })
    },
    removeMetaInfo: function (meta) {
      this.body.user.meta = this.body.user.meta.filter(function (obj) {
        return obj.key !== meta.key
      })
    },
    saveUser() {
      this.$validator.validateAll()
      if (!this.errors.any()) {
        this.body.groups = this.getSelectGroups()
        var body = JSON.parse(JSON.stringify(this.body)) // Me desculpa, mas precisei fazer isso devido as referencias
        body.user.meta = body.user.meta
          .filter(h => h.key !== undefined && h.key !== '' && h.key !== null)
          .map(function(meta) {
            var data = { }
            data[meta.key] = meta.value
            return data
          }).reduce(function(result, item) {
            var key = Object.keys(item)[0]
            result[key] = item[key]
            return result
          }, {})
        if (this.$route.params.id !== undefined) {
          axios.put(process.env.MYSTIQUE_MANAGER_API_URL + 'users/' + this.$route.params.id, body, {
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(response => {
            this.showSuccess('Usuário alterado com sucesso')
            this.$router.push('/mystique/users')
          }).catch(err => {
            console.error(err)
            this.showError('Ops. Ocorreu um erro ao salvar o usuário.')
          })
        } else {
          axios.post(process.env.MYSTIQUE_MANAGER_API_URL + 'users', body, {
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(response => {
            this.showSuccess('Usuário criado com sucesso')
            this.$router.push('/mystique/users')
          }).catch(err => {
            console.error(err)
            this.showError('Ops. Ocorreu um erro ao salvar o usuário.')
          })
        }
      }
    },
    loadGroups() {
      return axios.get(process.env.MYSTIQUE_MANAGER_API_URL + 'groups').then(response => {
        this.groups = response.data.map(function (data) {
          return {
            value: data.id,
            label: data.name
          }
        })
      }).catch(err => {
        console.error(err)
        this.showError('Ops. Ocorreu um erro ao listar os grupos.')
      })
    },
    loadMetaKeys() {
      return axios.get(process.env.MYSTIQUE_MANAGER_API_URL + 'users/meta').then(response => {
        this.metaKeys = response.data
      }).catch(err => {
        console.error(err)
      })
    },
    loadAccessKeys(id) {
      axios.get(process.env.MYSTIQUE_MANAGER_API_URL + 'access-keys?user_id=' + id).then(response => {
        this.accessKeys = response.data
      }).catch(err => {
        console.error(err)
        this.showError('Ops. Ocorreu um erro ao listar as chaves de acesso.')
      })
    },
    getSelectGroups() {
      if (this.selectedGroups) {
        return this.selectedGroups.map(function (data) {
          return data.value
        })
      } else {
        return null
      }
    },
    removeAccessKey(id) {
      axios.delete(process.env.MYSTIQUE_MANAGER_API_URL + 'access-keys/' + id).then(response => {
        this.loadAccessKeys(this.body.user.id)
        this.showSuccess('Chave de acesso removida com sucesso')
      }).catch(err => {
        console.error(err)
        this.showError('Ops. Ocorreu um erro ao remover a chave de acesso.')
      })
    },
    generateAccessKey() {
      axios.post(process.env.MYSTIQUE_MANAGER_API_URL + 'access-keys', {
        'userId': this.body.user.id
      }).then(response => {
        this.loadAccessKeys(this.body.user.id)
        this.showSuccess('Chave de acesso gerada com sucesso')
      }).catch(err => {
        console.error(err)
        this.showError('Ops. Ocorreu um erro ao gerar nova chave de acesso.')
      })
    }
  }
}
</script>
<style>
.metadata .dropdown-toggle {
  border-radius: 0px !important;
}

.metadata .dropdown-toggle .selected-tag {
  background-color: #fff;
  border-color: #fff;
}
</style>



// WEBPACK FOOTER //
// Form.vue?395b3102